import { RequestService } from '../../../../common/services/RequestService';
import { CHECK_USER_BY_PHONE_NUMBER } from '../constants';

export const getCheckUserByPhoneNumberRequest = async phone => {
  const response = await RequestService.get(
    CHECK_USER_BY_PHONE_NUMBER.replace('{phone}', phone)
  );
  return {
    phone,
    status: response.data
      ? response.data.isExist
        ? 'exist'
        : 'notExist'
      : 'error',
  };
};
